export default __webpack_public_path__ + "static/media/myapps_logo6.903e9fc6.png";